const base = {
  wechat: "//api.qingcigame.com", //微信授权专用
  url2: process.env.NODE_ENV === "production" ? "" : "//tsdk.qcplay.com", //国内
  // url2: process.env.NODE_ENV === "production" ? "" : "//tsdk-sg.qcplay.com", //海外
}

export default base
